import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ErrorApp from './views/ErrorApp.vue';
import { BadgePlugin, BootstrapVue, TooltipPlugin } from 'bootstrap-vue'
import { getConfig } from './util'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'


Vue.config.productionTip = false
// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

// Optionally install the BootstrapVue Tooltip and Badge components plugin
Vue.use(TooltipPlugin)
Vue.use(BadgePlugin)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
